export default __webpack_public_path__ + "static/jobs-83d8d781ff7d3b26f780c30a1ad8e796.png";